(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9164],{

/***/ 84875:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 672:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[categoryUrl]/[slug]",
      function () {
        return __webpack_require__(92075);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_v7vsrdtui4d36prbwvdnlb7tpq/node_modules/next/head.js
var head = __webpack_require__(61867);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_v7vsrdtui4d36prbwvdnlb7tpq/node_modules/next/script.js
var script = __webpack_require__(9932);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/ssrAdapter/index.js + 4 modules
var ssrAdapter = __webpack_require__(71346);
// EXTERNAL MODULE: ./src/components/templates/BlogTemplate/index.ts + 5 modules
var BlogTemplate = __webpack_require__(67825);
// EXTERNAL MODULE: ./src/scenes/Blog/scenes/BlogOverview/index.ts + 3 modules
var BlogOverview = __webpack_require__(82353);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-i18next@11.3.0_ufcdradhd47ev6f6p6esikefua/node_modules/next-i18next/dist/esm/index.js + 14 modules
var esm = __webpack_require__(16563);
// EXTERNAL MODULE: ./workspaces/packages/component-library/src/index.ts + 10 modules
var src = __webpack_require__(79773);
// EXTERNAL MODULE: ./src/scenes/Blog/scenes/components/ReducedBlogPost/index.ts + 2 modules
var ReducedBlogPost = __webpack_require__(96991);
// EXTERNAL MODULE: ./src/services/tracking/index.ts + 1 modules
var tracking = __webpack_require__(76774);
// EXTERNAL MODULE: ./src/utils/hooks/index.ts + 3 modules
var hooks = __webpack_require__(22090);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(43119);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.1.1_7i5myeigehqah43i5u7wbekgba/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(61258);
;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/Content/Content.styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: ",
        ";\n	text-decoration: none;\n\n	&:hover,\n	&:focus {\n		filter: brightness(1.1);\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		margin-bottom: 40px;\n	"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	margin-bottom: 100px;\n\n	",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 3.2rem;\n		line-height: 1.1875;\n		margin: 32px 0 16px;\n	"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 4.8rem;\n	font-weight: 700;\n	line-height: 1;\n	margin: 40px 0 8px;\n\n	",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 2.4rem;\n		line-height: 1.25;\n		margin: 24px 0 8px;\n	"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 3.2rem;\n	font-weight: 700;\n	line-height: 1.1875;\n	margin: 32px 0 8px;\n\n	",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 2.0rem;\n	"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 2.4rem;\n	font-weight: 700;\n	line-height: 1.25;\n	margin: 24px 0 0;\n\n	",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 1.8rem;\n	"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 2rem;\n	font-weight: 700;\n	line-height: 1.25;\n	margin: 20px 0 0;\n\n	",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 1.6rem;\n	"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 1.8rem;\n	font-weight: 700;\n	line-height: 1.25;\n	margin: 20px 0 0;\n\n	",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 1.6rem;\n	"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 1.8rem;\n	font-weight: 600;\n	line-height: 1.25;\n	margin: 16px 0 0;\n\n	",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	background-color: ",
        ";\n	border: 0;\n	height: 1px;\n	margin: 8px 0;\n	width: 100%;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 16px auto 8px;\n	max-width: 100%;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: center;\n	margin: auto;\n	max-width: 460px;\n	width: 100%;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: block;\n	margin: auto;\n	max-width: 100%;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	& > iframe {\n		margin: 16px auto 8px !important;\n	}\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 1.6rem;\n	font-weight: 400;\n	line-height: 1.5;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 16px 0 8px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 1.6rem;\n	font-weight: 400;\n	line-height: 1.5;\n	margin: 16px 0 8px;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	white-space: pre-wrap;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 16px 0 8px;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}


var media = src/* mixins.media */.tA.BC;
var StyledAnchor = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-7dca00b4-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary.main;
});
var ContentWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-7dca00b4-1"
})(_templateObject2(), media.belowLarge(_templateObject1()));
var StyledHeading1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-7dca00b4-2"
})(_templateObject4(), media.belowLarge(_templateObject3()));
var StyledHeading2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-7dca00b4-3"
})(_templateObject6(), media.belowLarge(_templateObject5()));
var StyledHeading3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-7dca00b4-4"
})(_templateObject8(), media.belowLarge(_templateObject7()));
var StyledHeading4 = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-7dca00b4-5"
})(_templateObject10(), media.belowLarge(_templateObject9()));
var StyledHeading5 = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-7dca00b4-6"
})(_templateObject12(), media.belowLarge(_templateObject11()));
var StyledHeading6 = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    componentId: "sc-7dca00b4-7"
})(_templateObject14(), media.belowLarge(_templateObject13()));
var StyledHorizontalRule = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    componentId: "sc-7dca00b4-8"
})(_templateObject15(), function(param) {
    var theme = param.theme;
    return theme.colors.line;
});
var StyledIframe = styled_components_browser_esm/* default.iframe.attrs */.ZP.iframe.attrs({
    height: 394,
    width: 700
}).withConfig({
    componentId: "sc-7dca00b4-9"
})(_templateObject16());
var StyledImageContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7dca00b4-10"
})(_templateObject17());
var StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-7dca00b4-11"
})(_templateObject18());
var StyledInstagramContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7dca00b4-12"
})(_templateObject19());
var StyledListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-7dca00b4-13"
})(_templateObject20());
var StyledOrderedList = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
    componentId: "sc-7dca00b4-14"
})(_templateObject21());
var StyledParagraph = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-7dca00b4-15"
})(_templateObject22());
var StyledPre = styled_components_browser_esm/* default.pre.withConfig */.ZP.pre.withConfig({
    componentId: "sc-7dca00b4-16"
})(_templateObject23());
var StyledUnorderedList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-7dca00b4-17"
})(_templateObject24());

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/Content/Content.tsx









var Anchor = function(_param) {
    var href = _param.href, props = (0,_object_without_properties/* default */.Z)(_param, [
        "href"
    ]);
    var trackAnchorClick = (0,react.useCallback)(function() {
        ssrAdapter/* analytics.track */.co.track(tracking/* events.MAIN_CONTENT_INTERACTION_CLICKED */.U.MAIN_CONTENT_INTERACTION_CLICKED, {
            contentType: "link",
            destinationUrl: href
        });
    }, [
        href
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAnchor, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        href: href,
        onClick: trackAnchorClick
    }));
};
var YouTubeIframe = function(_param) {
    var src = _param.src, props = (0,_object_without_properties/* default */.Z)(_param, [
        "src"
    ]);
    var ref = (0,react.useState)(false), clicked = ref[0], setClicked = ref[1];
    var trackVideoClick = (0,react.useCallback)(function() {
        if (clicked) {
            return;
        }
        ssrAdapter/* analytics.track */.co.track(tracking/* events.MAIN_CONTENT_INTERACTION_CLICKED */.U.MAIN_CONTENT_INTERACTION_CLICKED, {
            contentType: "video",
            destinationUrl: src
        });
        setClicked(true);
    }, [
        clicked,
        src
    ]);
    if (!src || !src.startsWith("https://www.youtube.com")) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIframe, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        src: src
    }, props), {
        onClick: trackVideoClick
    }));
};
var BlockQuote = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInstagramContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", (0,_object_spread/* default */.Z)({}, props))
    });
};
var Image = function(param) {
    var src = param.src;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(StyledImageContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
            alt: "",
            src: (src === null || src === void 0 ? void 0 : src.startsWith("http")) ? src : "https:".concat(src)
        })
    });
};
var components = {
    a: Anchor,
    blockquote: BlockQuote,
    h1: StyledHeading1,
    h2: StyledHeading2,
    h3: StyledHeading3,
    h4: StyledHeading4,
    h5: StyledHeading5,
    h6: StyledHeading6,
    hr: StyledHorizontalRule,
    iframe: YouTubeIframe,
    img: Image,
    li: StyledListItem,
    ol: StyledOrderedList,
    p: StyledParagraph,
    pre: StyledPre,
    ul: StyledUnorderedList
};
var Content = function(param) {
    var content = param.post.content;
    return content ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* MarkDown */.sd, {
            components: components,
            content: content
        })
    }) : null;
};
/* harmony default export */ var Content_Content = (Content);

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/Content/index.ts
// eslint-disable-next-line no-restricted-exports


// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_v7vsrdtui4d36prbwvdnlb7tpq/node_modules/next/image.js
var next_image = __webpack_require__(13353);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/Header/Header.styles.ts

function Header_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 1.4rem;\n	font-weight: 400;\n	line-height: 1;\n	margin: 12px 0 0;\n"
    ]);
    Header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	max-width: 100%;\n	width: 100%;\n"
    ]);
    Header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding-top: 16px;\n	width: 100%;\n"
    ]);
    Header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Header_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 3.2rem;\n		line-height: 1.1875;\n		margin: 32px 0 16px;\n	"
    ]);
    Header_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Header_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 4.8rem;\n	font-weight: 700;\n	line-height: 1;\n	margin: 40px 0 8px;\n\n	",
        "\n"
    ]);
    Header_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Header_styles_media = src/* mixins.media */.tA.BC;
var Author = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1b885af-0"
})(Header_styles_templateObject());
var Header_styles_Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1b885af-1"
})(Header_styles_templateObject1());
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1b885af-2"
})(Header_styles_templateObject2());
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-1b885af-3"
})(Header_styles_templateObject4(), Header_styles_media.belowLarge(Header_styles_templateObject3()));

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/Header/Header.tsx





var MAX_HEADER_WIDTH = 700;
var Header_Author = function(param) {
    var author = param.author;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
        children: author
    });
};
var Header = function(param) {
    var _post = param.post, author = _post.author, coverImage = _post.coverImage, title = _post.title;
    var t = (0,esm/* useTranslation */.$G)("blog").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
        children: [
            (coverImage === null || coverImage === void 0 ? void 0 : coverImage.dimensions) && (coverImage === null || coverImage === void 0 ? void 0 : coverImage.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: coverImage.description,
                height: coverImage.dimensions.height * (MAX_HEADER_WIDTH / coverImage.dimensions.width),
                src: coverImage.url,
                width: MAX_HEADER_WIDTH
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_styles_Image, {
                alt: coverImage === null || coverImage === void 0 ? void 0 : coverImage.description,
                src: coverImage === null || coverImage === void 0 ? void 0 : coverImage.url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Author, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                    i18nKey: "blog.post.author",
                    t: t,
                    components: {
                        author: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Author, {
                            author: author
                        }, "author")
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            })
        ]
    });
};
/* harmony default export */ var Header_Header = (Header);

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/Header/index.ts
// eslint-disable-next-line no-restricted-exports


;// CONCATENATED MODULE: ./node_modules/.pnpm/react-share@4.4.1_react@18.2.0/node_modules/react-share/es/utils/objectToGetParams.js
function objectToGetParams(object) {
    var params = Object.entries(object)
        .filter(function (_a) {
        var value = _a[1];
        return value !== undefined && value !== null;
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
    });
    return params.length > 0 ? "?".concat(params.join('&')) : '';
}

// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.2/node_modules/classnames/index.js
var classnames = __webpack_require__(84875);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-share@4.4.1_react@18.2.0/node_modules/react-share/es/ShareButton.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var isPromise = function (obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};
var getBoxPositionOnWindowCenter = function (width, height) { return ({
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2,
}); };
var getBoxPositionOnScreenCenter = function (width, height) { return ({
    top: (window.screen.height - height) / 2,
    left: (window.screen.width - width) / 2,
}); };
function windowOpen(url, _a, onClose) {
    var height = _a.height, width = _a.width, configRest = __rest(_a, ["height", "width"]);
    var config = __assign({ height: height, width: width, location: 'no', toolbar: 'no', status: 'no', directories: 'no', menubar: 'no', scrollbars: 'yes', resizable: 'no', centerscreen: 'yes', chrome: 'yes' }, configRest);
    var shareDialog = window.open(url, '', Object.keys(config)
        .map(function (key) { return "".concat(key, "=").concat(config[key]); })
        .join(', '));
    if (onClose) {
        var interval_1 = window.setInterval(function () {
            try {
                if (shareDialog === null || shareDialog.closed) {
                    window.clearInterval(interval_1);
                    onClose(shareDialog);
                }
            }
            catch (e) {
                /* eslint-disable no-console */
                console.error(e);
                /* eslint-enable no-console */
            }
        }, 1000);
    }
    return shareDialog;
}
var ShareButton = /** @class */ (function (_super) {
    __extends(ShareButton, _super);
    function ShareButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openShareDialog = function (link) {
            var _a = _this.props, onShareWindowClose = _a.onShareWindowClose, _b = _a.windowHeight, windowHeight = _b === void 0 ? 400 : _b, _c = _a.windowPosition, windowPosition = _c === void 0 ? 'windowCenter' : _c, _d = _a.windowWidth, windowWidth = _d === void 0 ? 550 : _d;
            var windowConfig = __assign({ height: windowHeight, width: windowWidth }, (windowPosition === 'windowCenter'
                ? getBoxPositionOnWindowCenter(windowWidth, windowHeight)
                : getBoxPositionOnScreenCenter(windowWidth, windowHeight)));
            windowOpen(link, windowConfig, onShareWindowClose);
        };
        _this.handleClick = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, beforeOnClick, disabled, networkLink, onClick, url, openShareDialogOnClick, opts, link, returnVal;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, beforeOnClick = _a.beforeOnClick, disabled = _a.disabled, networkLink = _a.networkLink, onClick = _a.onClick, url = _a.url, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts;
                        link = networkLink(url, opts);
                        if (disabled) {
                            return [2 /*return*/];
                        }
                        event.preventDefault();
                        if (!beforeOnClick) return [3 /*break*/, 2];
                        returnVal = beforeOnClick();
                        if (!isPromise(returnVal)) return [3 /*break*/, 2];
                        return [4 /*yield*/, returnVal];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (openShareDialogOnClick) {
                            this.openShareDialog(link);
                        }
                        if (onClick) {
                            onClick(event, link);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    ShareButton.prototype.render = function () {
        var _a = this.props, beforeOnClick = _a.beforeOnClick, children = _a.children, className = _a.className, disabled = _a.disabled, disabledStyle = _a.disabledStyle, forwardedRef = _a.forwardedRef, networkLink = _a.networkLink, networkName = _a.networkName, onShareWindowClose = _a.onShareWindowClose, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts, resetButtonStyle = _a.resetButtonStyle, style = _a.style, url = _a.url, windowHeight = _a.windowHeight, windowPosition = _a.windowPosition, windowWidth = _a.windowWidth, rest = __rest(_a, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]);
        var newClassName = classnames_default()('react-share__ShareButton', {
            'react-share__ShareButton--disabled': !!disabled,
            disabled: !!disabled,
        }, className);
        var newStyle = resetButtonStyle
            ? __assign(__assign({ backgroundColor: 'transparent', border: 'none', padding: 0, font: 'inherit', color: 'inherit', cursor: 'pointer' }, style), (disabled && disabledStyle)) : __assign(__assign({}, style), (disabled && disabledStyle));
        return (react.createElement("button", __assign({}, rest, { "aria-label": rest['aria-label'] || networkName, className: newClassName, onClick: this.handleClick, ref: forwardedRef, style: newStyle }), children));
    };
    ShareButton.defaultProps = {
        disabledStyle: { opacity: 0.6 },
        openShareDialogOnClick: true,
        resetButtonStyle: true,
    };
    return ShareButton;
}(react.Component));
/* harmony default export */ var es_ShareButton = (ShareButton);

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-share@4.4.1_react@18.2.0/node_modules/react-share/es/hocs/createShareButton.js
var createShareButton_assign = (undefined && undefined.__assign) || function () {
    createShareButton_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return createShareButton_assign.apply(this, arguments);
};


function createShareButton(networkName, link, optsMap, defaultProps) {
    function CreatedButton(props, ref) {
        var opts = optsMap(props);
        var passedProps = createShareButton_assign({}, props);
        // remove keys from passed props that are passed as opts
        var optsKeys = Object.keys(opts);
        optsKeys.forEach(function (key) {
            delete passedProps[key];
        });
        return (react.createElement(es_ShareButton, createShareButton_assign({}, defaultProps, passedProps, { forwardedRef: ref, networkName: networkName, networkLink: link, opts: optsMap(props) })));
    }
    CreatedButton.displayName = "ShareButton-".concat(networkName);
    return (0,react.forwardRef)(CreatedButton);
}
/* harmony default export */ var hocs_createShareButton = (createShareButton);

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-share@4.4.1_react@18.2.0/node_modules/react-share/es/EmailShareButton.js


function emailLink(url, _a) {
    var subject = _a.subject, body = _a.body, separator = _a.separator;
    return 'mailto:' + objectToGetParams({ subject: subject, body: body ? body + separator + url : url });
}
var EmailShareButton = hocs_createShareButton('email', emailLink, function (props) { return ({
    subject: props.subject,
    body: props.body,
    separator: props.separator || ' ',
}); }, {
    openShareDialogOnClick: false,
    onClick: function (_, link) {
        window.location.href = link;
    },
});
/* harmony default export */ var es_EmailShareButton = (EmailShareButton);

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-share@4.4.1_react@18.2.0/node_modules/react-share/es/utils/assert.js
var assert_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AssertionError = /** @class */ (function (_super) {
    assert_extends(AssertionError, _super);
    function AssertionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'AssertionError';
        return _this;
    }
    return AssertionError;
}(Error));
function assert(value, message) {
    if (!value) {
        throw new AssertionError(message);
    }
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-share@4.4.1_react@18.2.0/node_modules/react-share/es/FacebookShareButton.js



function facebookLink(url, _a) {
    var quote = _a.quote, hashtag = _a.hashtag;
    assert(url, 'facebook.url');
    return ('https://www.facebook.com/sharer/sharer.php' +
        objectToGetParams({
            u: url,
            quote: quote,
            hashtag: hashtag,
        }));
}
var FacebookShareButton = hocs_createShareButton('facebook', facebookLink, function (props) { return ({
    quote: props.quote,
    hashtag: props.hashtag,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_FacebookShareButton = (FacebookShareButton);

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-share@4.4.1_react@18.2.0/node_modules/react-share/es/TwitterShareButton.js



function twitterLink(url, _a) {
    var title = _a.title, via = _a.via, _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.related, related = _c === void 0 ? [] : _c;
    assert(url, 'twitter.url');
    assert(Array.isArray(hashtags), 'twitter.hashtags is not an array');
    assert(Array.isArray(related), 'twitter.related is not an array');
    return ('https://twitter.com/share' +
        objectToGetParams({
            url: url,
            text: title,
            via: via,
            hashtags: hashtags.length > 0 ? hashtags.join(',') : undefined,
            related: related.length > 0 ? related.join(',') : undefined,
        }));
}
var TwitterShareButton = hocs_createShareButton('twitter', twitterLink, function (props) { return ({
    hashtags: props.hashtags,
    title: props.title,
    via: props.via,
    related: props.related,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_TwitterShareButton = (TwitterShareButton);

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-share@4.4.1_react@18.2.0/node_modules/react-share/es/WhatsappShareButton.js



function isMobileOrTablet() {
    return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
}
function whatsappLink(url, _a) {
    var title = _a.title, separator = _a.separator;
    assert(url, 'whatsapp.url');
    return ('https://' +
        (isMobileOrTablet() ? 'api' : 'web') +
        '.whatsapp.com/send' +
        objectToGetParams({
            text: title ? title + separator + url : url,
        }));
}
var WhatsappShareButton = hocs_createShareButton('whatsapp', whatsappLink, function (props) { return ({
    title: props.title,
    separator: props.separator || ' ',
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_WhatsappShareButton = (WhatsappShareButton);

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/SocialShare/SocialShare.styles.ts

function SocialShare_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 88px 20px 108px 0;\n	display: flex;\n	flex-direction: column;\n	gap: 8px;\n	position: sticky;\n	top: 88px;\n	align-self: baseline;\n"
    ]);
    SocialShare_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	bottom: 16px;\n	right: 16px;\n	display: flex;\n	flex-direction: column-reverse;\n	align-items: center;\n	gap: 16px;\n	z-index: 1;\n"
    ]);
    SocialShare_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: ",
        ";\n	overflow: hidden;\n	border-radius: 32px;\n	box-shadow: ",
        ";\n	background-color: ",
        ";\n	transition: height 0.15s ease-in;\n"
    ]);
    SocialShare_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column-reverse;\n	gap: 8px;\n	padding: 16px 8px;\n"
    ]);
    SocialShare_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 48px;\n	height: 48px;\n	border-radius: 50%;\n	background-color: ",
        ";\n\n	svg {\n		fill: ",
        ";\n	}\n\n	&:hover,\n	&:active {\n		background-color: ",
        ";\n	}\n"
    ]);
    SocialShare_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	svg {\n		fill: ",
        ";\n	}\n"
    ]);
    SocialShare_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 44px;\n	height: 44px;\n	display: inline-flex;\n	align-items: center;\n	justify-content: center;\n	background: none;\n	border-radius: 4px;\n	text-decoration: none;\n	transition: all 0.15s;\n\n	&:hover {\n		background-color: ",
        ";\n	}\n\n	svg {\n		fill: ",
        ";\n	}\n"
    ]);
    SocialShare_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 44px;\n	height: 44px;\n\n	&:focus {\n		box-shadow: ",
        ";\n	}\n"
    ]);
    SocialShare_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    SocialShare_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    SocialShare_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    SocialShare_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    SocialShare_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}



var BigScreenWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5db11773-0"
})(SocialShare_styles_templateObject());
var SmallScreenWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5db11773-1"
})(SocialShare_styles_templateObject1());
var SmallScreenButtonsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5db11773-2"
})(SocialShare_styles_templateObject2(), function(param) {
    var expanded = param.expanded;
    return expanded ? "232px" : "0";
}, function(param) {
    var theme = param.theme;
    return theme.shadows.subtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var SmallScreenButtonsList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5db11773-3"
})(SocialShare_styles_templateObject3());
var SmallScreenShareButton = (0,styled_components_browser_esm/* default */.ZP)(ssrAdapter/* IconButton */.hU).withConfig({
    componentId: "sc-5db11773-4"
})(SocialShare_styles_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.grey[900];
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey[400];
});
var SocialShare_styles_ShareButton = (0,styled_components_browser_esm/* default */.ZP)(ssrAdapter/* IconButton */.hU).withConfig({
    componentId: "sc-5db11773-5"
})(SocialShare_styles_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.grey[900];
});
var ShareButtonIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5db11773-6"
})(SocialShare_styles_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.grey[200];
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey[900];
});
var shareButtonCss = (0,styled_components_browser_esm/* css */.iv)(SocialShare_styles_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.misc.focusShadow;
});
var StyledEmailShareButton = (0,styled_components_browser_esm/* default */.ZP)(es_EmailShareButton).withConfig({
    componentId: "sc-5db11773-7"
})(SocialShare_styles_templateObject8(), shareButtonCss);
var StyledFacebookShareButton = (0,styled_components_browser_esm/* default */.ZP)(es_FacebookShareButton).withConfig({
    componentId: "sc-5db11773-8"
})(SocialShare_styles_templateObject9(), shareButtonCss);
var StyledTwitterShareButton = (0,styled_components_browser_esm/* default */.ZP)(es_TwitterShareButton).withConfig({
    componentId: "sc-5db11773-9"
})(SocialShare_styles_templateObject10(), shareButtonCss);
var StyledWhatsappShareButton = (0,styled_components_browser_esm/* default */.ZP)(es_WhatsappShareButton).withConfig({
    componentId: "sc-5db11773-10"
})(SocialShare_styles_templateObject11(), shareButtonCss);

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/SocialShare/SocialShare.tsx







var mediaQueries = src/* mixins.mediaQueries */.tA.w5;
var SocialShare = function(param) {
    var contentName = param.contentName, pageUrl = param.pageUrl;
    var ref = (0,hooks/* useEditableModal */.M7)(), isOpen = ref.isOpen, close = ref.close, toggle = ref.toggle;
    var isLargeScreen = (0,hooks/* useMediaQuery */.ac)(mediaQueries.large);
    var trackShareClick = (0,react.useCallback)(function(shareType) {
        ssrAdapter/* analytics.track */.co.track(tracking/* events.SHARE_CLICKED */.U.SHARE_CLICKED, {
            contentName: contentName,
            shareType: shareType
        });
    }, [
        contentName
    ]);
    var shareButtons = (0,react.useMemo)(function() {
        return {
            email: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEmailShareButton, {
                beforeOnClick: function() {
                    return trackShareClick("email");
                },
                url: pageUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButtonIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssrAdapter/* MaterialIcons.Email */.YJ.GTk, {
                        size: 29
                    })
                })
            }),
            facebook: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFacebookShareButton, {
                onShareWindowClose: function() {
                    return trackShareClick("facebook");
                },
                url: pageUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButtonIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssrAdapter/* CustomIcons.Facebook */.ew.s1, {
                        size: 29
                    })
                })
            }),
            twitter: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTwitterShareButton, {
                onShareWindowClose: function() {
                    return trackShareClick("twitter");
                },
                url: pageUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButtonIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssrAdapter/* CustomIcons.Twitter */.ew.tL, {
                        size: 29
                    })
                })
            }),
            whatsapp: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhatsappShareButton, {
                onShareWindowClose: function() {
                    return trackShareClick("whatsapp");
                },
                url: pageUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButtonIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssrAdapter/* CustomIcons.WhatsApp */.ew.w2, {
                        size: 29
                    })
                })
            })
        };
    }, [
        pageUrl,
        trackShareClick
    ]);
    (0,react.useEffect)(function() {
        close();
    }, [
        isLargeScreen
    ]);
    return isLargeScreen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(BigScreenWrapper, {
        children: [
            shareButtons.email,
            shareButtons.facebook,
            shareButtons.twitter,
            shareButtons.whatsapp
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallScreenWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallScreenShareButton, {
                onClick: toggle,
                children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ssrAdapter/* MaterialIcons.Close */.YJ.x8P, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ssrAdapter/* MaterialIcons.Share */.YJ.mBz, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallScreenButtonsWrapper, {
                expanded: isOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallScreenButtonsList, {
                    children: [
                        shareButtons.whatsapp,
                        shareButtons.twitter,
                        shareButtons.facebook,
                        shareButtons.email
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var SocialShare_SocialShare = (SocialShare);

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/SocialShare/index.ts
// eslint-disable-next-line no-restricted-exports


;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/index.ts




;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/constants.ts

var constants_mediaQueries = src/* mixins.mediaQueries */.tA.w5;
var RELATED_POSTS_GRID_GAP = 24;
var RELATED_POSTS_MAX_WIDTH = 969;
var RELATED_POSTS_VIEWPORT_WIDTH = 100;
var RELATED_POSTS_VERTICAL_PADDING = 24;
var POSTS_PER_ROW_BELOW_MEDIUM = 1;
var POSTS_PER_ROW_BELOW_LARGE = 2;
var POSTS_PER_ROW_ABOVE_LARGE = 3;
var MAX_LARGE_IMAGE_WIDTH = Math.ceil((RELATED_POSTS_MAX_WIDTH - (POSTS_PER_ROW_ABOVE_LARGE - 1) * RELATED_POSTS_GRID_GAP) / POSTS_PER_ROW_ABOVE_LARGE);
var REDUCED_BLOG_POST_IMAGE_SIZES = "".concat(constants_mediaQueries.belowMedium, " ").concat(RELATED_POSTS_VIEWPORT_WIDTH / POSTS_PER_ROW_BELOW_MEDIUM, "vw, ").concat(constants_mediaQueries.belowLarge, " ").concat(RELATED_POSTS_VIEWPORT_WIDTH / POSTS_PER_ROW_BELOW_LARGE, "vw, ").concat(constants_mediaQueries.belowXLarge, " ").concat(RELATED_POSTS_VIEWPORT_WIDTH / POSTS_PER_ROW_ABOVE_LARGE, "vw, ").concat(MAX_LARGE_IMAGE_WIDTH, "px");

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/BlogPost.styles.ts

function BlogPost_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		justify-content: center;\n	"
    ]);
    BlogPost_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: row;\n	justify-content: space-between;\n	margin: auto;\n	max-width: 888px;\n	padding: 0 20px;\n\n	",
        "\n"
    ]);
    BlogPost_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	max-width: 700px;\n"
    ]);
    BlogPost_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	align-items: center;\n	border-top: ",
        ";\n	display: flex;\n	flex-direction: column;\n	margin: auto;\n	max-width: ",
        "px;\n	padding: 40px 0 96px;\n"
    ]);
    BlogPost_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 3.2rem;\n	font-weight: 700;\n	line-height: 1.1875;\n	margin-bottom: 64px;\n	text-align: center;\n"
    ]);
    BlogPost_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		padding: 0 ",
        "px;\n	"
    ]);
    BlogPost_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			max-width: calc(",
        "% - 12px);\n		"
    ]);
    BlogPost_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			max-width: ",
        "%;\n		"
    ]);
    BlogPost_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-wrap: wrap;\n	gap: ",
        "px;\n	justify-content: center;\n	width: ",
        "%;\n\n	",
        "\n\n	& > * {\n		max-width: calc(",
        "% - 16px);\n		width: 100%;\n\n		",
        "\n\n		",
        "\n	}\n"
    ]);
    BlogPost_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var BlogPost_styles_media = src/* mixins.media */.tA.BC;
var StyledBlogPost = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-3781d617-0"
})(BlogPost_styles_templateObject1(), BlogPost_styles_media.belowLarge(BlogPost_styles_templateObject()));
var StyledMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3781d617-1"
})(BlogPost_styles_templateObject2());
var StyledRelatedPosts = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3781d617-2"
})(BlogPost_styles_templateObject3(), function(param) {
    var theme = param.theme;
    return "2px solid ".concat(theme.colors.grey[120]);
}, RELATED_POSTS_MAX_WIDTH);
var StyledRelatedPostsTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-3781d617-3"
})(BlogPost_styles_templateObject4());
var StyledRelatedPostsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3781d617-4"
})(BlogPost_styles_templateObject8(), RELATED_POSTS_GRID_GAP, RELATED_POSTS_VIEWPORT_WIDTH, BlogPost_styles_media.belowLarge(BlogPost_styles_templateObject5(), RELATED_POSTS_VERTICAL_PADDING), 100 / POSTS_PER_ROW_ABOVE_LARGE, BlogPost_styles_media.belowLarge(BlogPost_styles_templateObject6(), 100 / POSTS_PER_ROW_BELOW_LARGE), BlogPost_styles_media.belowMedium(BlogPost_styles_templateObject7(), 100 / POSTS_PER_ROW_BELOW_MEDIUM));

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/BlogPost.tsx











var BlogPost_mediaQueries = src/* mixins.mediaQueries */.tA.w5;
var BlogPost = function(param) {
    var pageUrl = param.pageUrl, post = param.post, relatedPosts = param.relatedPosts;
    var t = (0,esm/* useTranslation */.$G)("blog").t;
    var isLargeScreen = (0,hooks/* useMediaQuery */.ac)(BlogPost_mediaQueries.large);
    var trackContentClick = (0,react.useCallback)(function(properties) {
        ssrAdapter/* analytics.track */.co.track(tracking/* events.CONTENT_CLICKED */.U.CONTENT_CLICKED, properties);
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        ssrAdapter/* analytics.page */.co.page("Content", "Blog", {
            contentType: "Blog",
            estimatedPostLength: (ref = post.content) === null || ref === void 0 ? void 0 : ref.length,
            pageType: "Content",
            pageCategory: post.category
        });
    }, [
        post
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBlogPost, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare_SocialShare, {
                        contentName: post.title,
                        pageUrl: pageUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMain, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {
                                post: post
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Content, {
                                post: post
                            })
                        ]
                    })
                ]
            }),
            relatedPosts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRelatedPosts, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRelatedPostsTitle, {
                        children: t("blog.post.relatedPosts")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRelatedPostsContainer, {
                        children: relatedPosts.map(function(relatedPost, k) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReducedBlogPost/* default */.Z, {
                                onClick: function() {
                                    return trackContentClick({
                                        destinationContentName: relatedPost.title,
                                        contentType: "Blog",
                                        destinationUrl: relatedPost.urlPath,
                                        location: "related post panel",
                                        position: k + 1
                                    });
                                },
                                post: relatedPost,
                                shouldShowSummary: isLargeScreen,
                                imageSizes: REDUCED_BLOG_POST_IMAGE_SIZES
                            }, relatedPost.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ssrAdapter/* MarketingCTARow */.$2, {
                cta: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssrAdapter/* MarketingSignup */.yW, {}),
                title: t("blog.cta.title")
            })
        ]
    });
};
/* harmony default export */ var BlogPost_BlogPost = (BlogPost);

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/index.ts
// eslint-disable-next-line no-restricted-exports


;// CONCATENATED MODULE: ./src/scenes/Blog/index.ts



;// CONCATENATED MODULE: ./src/pages/blog/[categoryUrl]/[slug].tsx






var Post = function(param) {
    var activeCategory = param.activeCategory, pageUrl = param.pageUrl, post = param.post, relatedPosts = param.relatedPosts, user = param.user;
    var ref;
    (0,ssrAdapter/* useLoadAnalytics */.O3)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "canonical",
                    href: pageUrl
                })
            }),
            ((ref = post.content) === null || ref === void 0 ? void 0 : ref.includes("https://www.instagram.com")) && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "instagram",
                src: "https://www.instagram.com/embed.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogTemplate/* default */.Z, {
                activeCategory: activeCategory,
                user: user,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogPost_BlogPost, {
                    post: post,
                    relatedPosts: relatedPosts,
                    pageUrl: pageUrl
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (Post);


/***/ }),

/***/ 9932:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51740)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4668,5062,7052,3353,2296,7337,9842,7260,6863,3795,1346,9560,9774,2888,179], function() { return __webpack_exec__(672); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);